// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.coinomi",
    name: "Coinomi",
    homepage: "https://www.coinomi.com/",
    image_id: "3b446d16-a908-40c8-5835-9a6efe90dd00",
    app: {
        browser: null,
        ios: "https://itunes.apple.com/app/coinomi-wallet/id1333588809",
        android: "https://play.google.com/store/apps/details?id=com.coinomi.wallet",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "coinomi://",
        universal: "https://coinomi.page.link",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map